import { render } from "./searchProducts.vue?vue&type=template&id=e56de2c6"
import script from "./searchProducts.vue?vue&type=script&lang=js"
export * from "./searchProducts.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__